export default __webpack_public_path__ + "static/media/tschangoFiverrFeedback.e2d55cac.png";